import { z } from '@lucidlink/dto/z';
import { createDrawerCodec } from './createDrawerCodec.helper';
export const CreateGuestLinkCodec = createDrawerCodec('createGuestLink', [
    ['workspaceId', z.string().nonempty()],
    ['filespaceId', z.string().nonempty()],
    ['creationMutationKey', z.string().nonempty().optional()],
]);
